import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import { Link, Stack, Checkbox } from '@mui/material';

import useSearchParam from '../../hooks/useSearchParam';

import userLogin from '../../utils/apis/user/userLogin';
import passOnInviteToken from '../../utils/apis/user/passOnInviteToken';
import LoginInviteModal from './LoginInviteModal';
import LoginBtns from './LoginBtns';
import LoginInputForm from './LoginInputForm';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const { t } = useTranslation(['page']);

  const { param: inviteToken } = useSearchParam('invite_token');

  const navigate = useNavigate();

  // 초대자 이름
  const [inviteOrgName, setInviteOrgName] = useState('');
  const [shownModal, setShownModal] = useState(false);

  const [values, setValues] = useState({
    email: '',
    password: '',
    inviteUser: inviteToken,
  });

  const onChangeInput = (e) => {
    setValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClick = useCallback(
    (e) => {
      userLogin(values)
        .then((response) => {
          if (response.data[0][0].result === 'fail') {
            alert(t('아이디와 비밀번호를 확인하여주십시오.'));
          } else {
            sessionStorage.setItem('login_info', JSON.stringify(response.data[0][0]));
            console.log(response.data[0][0]);
            navigate('/app', { replace: true });
          }
        })
        .catch((error) => {
          console.log('error', error);
        });
    },
    [navigate, values]
  );

  const GotoSignupPage = () => {
    navigate(`/signup${inviteToken.length !== 0 ? `?invite_token=${inviteToken}` : ''}`, { replace: true });
  };
  const GotoFindPage = () => {
    navigate(`/find`, { replace: true });
  };

  useEffect(() => {
    const keyUpEvent = (e) => {
      if (e.key === 'Enter') {
        handleClick();
      }
    };
    document.addEventListener('keyup', keyUpEvent);

    // clean up
    return () => {
      document.removeEventListener('keyup', keyUpEvent);
    };
  }, [handleClick]);

  // 초대 링크를 받고 접속한 유저 검증 후 모달 띄어주기 위함
  useEffect(() => {
    if (inviteToken !== '' && inviteToken !== null) {
      const getOrgName = async () => {
        try {
          const response = await passOnInviteToken(inviteToken);
          const _inviteOrgName = response.data[0][0].name;
          setInviteOrgName(_inviteOrgName);
          setValues((prev) => ({
            ...prev,
            inviteUser: inviteToken,
          }));
          setShownModal(true);
        } catch (error) {
          console.log('error', error);
        }
      };
      getOrgName();
    }
  }, [inviteToken]);

  return (
    <>
      <Stack spacing={8}>
        <LoginInputForm
          emailText={t('이메일을 입력하세요.')}
          pwText={t('비밀번호를 입력하세요.')}
          values={values}
          onChange={onChangeInput}
        />
        <LoginBtns onLogin={handleClick} loginText={t('로그인')} onSignup={GotoSignupPage} signupText={t('회원가입')} />
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor="remember">
          <Checkbox id="remember" name="remember" label="Remember me" />
          {t('아이디 저장')}
        </label>
        <Link variant="subtitle2" underline="hover" onClick={GotoFindPage}>
          {t('비밀번호 찾기')}
        </Link>
      </Stack>

      {shownModal && (
        <LoginInviteModal
          inviteOrgName={inviteOrgName}
          titleText={t('초대 전용 링크입니다')}
          bodyText={t('이미 계정이 있으면 로그인을, 신규회원이면 회원가입을 진행해 주세요')}
        />
      )}
    </>
  );
}
